import { render, staticRenderFns } from "./issueBonusLogTab.vue?vue&type=template&id=64cff92c&lang=pug"
import script from "./issueBonusLogTab.vue?vue&type=script&lang=js"
export * from "./issueBonusLogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports